import request from "@/utils/request";
// 登录
const login = (params) => request.post("/laiHi/web/admin/webLogin", params);
// 退出登录
// const loginOut = () => request.post("/apc/account/exit");
// 数据字典
const getDictCode = (params) =>
  request.post("/laiHi/common/queryListByDictCode", params);
// 协议列表
const getAgreementList = (params) =>
  request.post("/laiHi/web/systemSet/pageAgreement", params);
// 添加协议
const handleAgreement = (params) =>
  request.post("/laiHi/web/systemSet/addAgreement", params);
// 修改协议
const editAgreement = (params) =>
  request.post("/laiHi/web/systemSet/modifyAgreement", params);
// oss上传
const uploadOss = (params) =>
  request.post("/laiHi/common/uploadFile", params, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
// 删除协议
const deleteAgreement = (params) =>
  request.post("/laiHi/web/systemSet/deleteAgreement", params);
// 根据名称查询协议信息
const getInfo = (params) =>
  request.post("/laiHi/web/systemSet/selectAgreement", params);
// 获取反馈列表
const getFeedback = (params) =>
  request.post("/laiHi/web/systemSet/pageProblemFeedback", params);
// 获取用户列表
const getUserList = (params) =>
  request.post("/laiHi/web/user/pageUserList", params);
// 修改用户状态
const editUserStatus = (params) =>
  request.post("/laiHi/web/user/modifyUserStatus", params);
// 注销账户列表
const getLogoutList = (params) =>
  request.post("/laiHi/web/user/logoutAccountUserList", params);
// 注销用户
const setLogout = (params) =>
  request.post("/laiHi/web/user/logoutAccount", params);

// 获取版本信息列表
const getVersionsList = (params) =>
  request.post("/laiHi/web/systemSet/pageVersion", params);
// 上传版本信息
const uploadVersions = (params) =>
  request.post("/laiHi/web/systemSet/uploadVersion", params);
// 查询当前app版本下的游戏兼容信息
const getVersionsGame = (versionId) =>
  request.get(
    `/laiHi/web/systemSet/queryVersionGameCompatibility/${versionId}`
  );
export {
  login,
  getDictCode,
  getAgreementList,
  handleAgreement,
  uploadOss,
  deleteAgreement,
  getInfo,
  editAgreement,
  getUserList,
  editUserStatus,
  getLogoutList,
  setLogout,
  getFeedback,
  getVersionsList,
  uploadVersions,
  getVersionsGame,
};
